import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import SignupConfirmation from './SignupConfirmation';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, regisSuccess, error, message,
  } = state.auth;
  return {
    isLoading,
    regisSuccess,
    error,
    message,
  };
}

const Styled = withStyles(styles)(SignupConfirmation);

export default connect(
  mapStateToProps,
)(Styled);
